import React, { useEffect, useRef, useState } from "react";
import axios from "../../../API/axios";
import { getUserConfig } from "../../../Services/apiService";
import { JobSearch, icons } from "../../../config/imagesLink";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import JobApply from "../../JobSearch/JobApply";
import JobAction from "../../JobSearch/JobAction";
import BookmarkSharpIcon from "@mui/icons-material/BookmarkSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import { Tooltip } from "@mui/material";
import SuccessToast from "../../SuccessToast";
import WarningToast from "../../WarningToast";
import ErrorToast from "../../ErrorToast";
import { ShimmerDiv } from "@skeleton";
import { post } from "../../../config/imagesLink";
import { useTranslation } from "react-i18next";
import GoogleAdUnit from "../../../components/GoogleAdUnit";

const SavedJobs = ({
  getAllJobList,setTabsCount
}) => {
  // erUid = localStorage.getItem("userUid");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
    const language = localStorage.getItem("Lang");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const { t } = useTranslation();
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const userUid = localStorage.getItem("userUid");
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  //************************saved jobs Start  ************************//
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [savedJobs, setSavedJobs] = useState([]);
  const [isSavedJobs, setIsSavedJobs] = useState(new Set());
  const [hasMoreData, setHasMoreData] = useState(true);
  

  const isFetching = useRef(false)
  const debounceRef = useRef(null);

  // refs to avoid stale closures in scroll handler
  const loadingRef = useRef(loading);
  const pageRef = useRef(page);
  const totalPagesRef = useRef(totalPages);
  const savedJobsLenRef = useRef(savedJobs.length);

  useEffect(() => { loadingRef.current = loading; }, [loading]);
  useEffect(() => { pageRef.current = page; }, [page]);
  useEffect(() => { totalPagesRef.current = totalPages; }, [totalPages]);
  useEffect(() => { savedJobsLenRef.current = savedJobs.length; }, [savedJobs]);

 
  const [profileConfig, setProfileConfig] = useState([]);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      setProfileConfig(responseData);
    } catch (error) {
      if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true)
      }

    }
  };

  useEffect(() => { 
    const sessionId = localStorage.getItem("sessionId"); 
    if (sessionId) {
      (async () => { 
        await Promise.all([  
          userConfig() 
        ]);
      })();
    }
  }, []);


  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };


  const getSavedJobs = async (page) => {
    if (isFetching.current) return; // Prevent duplicate
    isFetching.current = true;
    setLoading(true)
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
      langKey: language === "en" ? "" : language,
    };
    try {
      const response = await axios.post(`ManageJob/GetSavedJobs`, data);
      const newPosts = response.data.responseData.jobsList || [];
      const apiTotal = response.data.responseData.paging?.totalPages || 1;
      setTotalPages(apiTotal);
       if ( response.status === 204 )
       {
        setError(true); 
        setHasMoreData(false);
        // setNextBatchLoading(false); 
        return;
      }

      // IMPORTANT: show duplicates too — append raw API items for pages > 1
      setSavedJobs((prev) => {
        if (page === 1) return newPosts;
        // append all returned items (allow same jobId duplicates)
        return [...prev, ...newPosts];
      });
       if (page >= response.data.responseData.paging.totalPages) {
        setHasMoreData(false);
      }
      setError(false);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };
  useEffect(() => {
    if (hasMoreData && page <= totalPages) {
      getSavedJobs(page);
    } 
  }, [page]);

  const handleInfiniteScroll = async () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 10 >= document.documentElement.scrollHeight &&
      !loading &&
      page < totalPages
    ) {
      setPage((prev) => prev + 1);
    }
  };

  // attach single scroll listener (uses refs to read latest state)
  useEffect(() => {
    const onScroll = () => {
      const currentLoading = loadingRef.current;
      const currentPage = pageRef.current;
      const currentTotal = totalPagesRef.current;
      const currentLen = savedJobsLenRef.current;

      if (
        window.innerHeight + document.documentElement.scrollTop + 10 >= document.documentElement.scrollHeight &&
        !currentLoading &&
        !isFetching.current &&
        (currentPage < currentTotal || (currentPage === currentTotal && currentLen % 12 !== 0))
      ) {
        if (debounceRef.current) return;
        debounceRef.current = setTimeout(() => {
          setPage((prev) => prev + 1);
          debounceRef.current = null;
        }, 300);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  // ----------------------------------------------------------------------------------
  // iski wahaj se ham set-count saved ke page ka chnage kar pa rahe h
  const updateSavedCount = (change) => {
    setTabsCount((prev) => ({
      ...prev,
      totalSavedJobs: (prev.totalSavedJobs || 0) + change,
    }));
  };


  const saveJob = async (jobId) => {
    console.log("Save Job ID===>", jobId)
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        console.log("save post", res);
        setToastMessage(res.data.message);
        getSavedJobs()
        setShowToast(true);
        updateSavedCount(1)
        // setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };


  const unsaveJob = async (jobId) => {
    console.log("Unsave Job ID===>", jobId)
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res?.data?.message);
        setShowToast(true);
        // getSavedJobs()
        setSavedJobs((prevJobs) => prevJobs?.filter(job => job?.jobId !== jobId));
        updateSavedCount(-1)
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e?.response?.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e?.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };
  // ----------------------------------------------------------------------------------

    const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };


  const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      if ((index + 1) % 12 === 0) {
        result.push({ isAd: true });
      }
    });
    return result;
  };
  const postsWithAds = getPostListWithAds(savedJobs);

  //************************saved jobs End  ************************//
  return (
    <>
      <div className="row card-container">
        <div className="jobCardHeader d-flex justify-content-between">
          {/* <div className="job-card-text">
            <h1 className="f-14 f-600 p-2">Saved Jobs ({savedJobs === undefined ? 0 : savedJobs?.length})</h1>
          </div> */}
        </div>
        {savedJobs.length === 0 && loading ? (
          // Display shimmer effect when loading
          <div className="row mt-2">
            {[...Array(6)].map((_, i) => (
              <div className="col-md-4" key={i}>
                <ShimmerDiv height={150} width={"100%"} />
              </div>
            ))}
          </div>
        ) : isError ? (

          <div className="mt-2 error-image-cont error-image-job">
            {/* Assuming 'post' is passed as a prop or imported */}
            <img src={post.errorSmall} alt="Error" width={200}/>
            {/* <p className="text-center">Failed to load jobs. Please try again later.</p> */}
          </div>
        ) :
          // savedJobs &&
          // savedJobs?.map((item, index) => {
          //   const now = moment();
          //   const itemTime = moment.utc(item?.creationTime);
          //   const duration = moment.duration(now.diff(itemTime));

          //   const years = duration.years();
          //   const months = duration.months();
          //   const days = duration.days();
          //   const hours = duration.hours();
          //   const minutes = duration.minutes();

          //   let result = '';

          //   if (years > 0) {
          //     result = `${years} year${years > 1 ? 's' : ''} ago`;
          //   } else if (months > 0) {
          //     result = `${months} month${months > 1 ? 's' : ''} ago`;
          //   } else if (days > 0) {
          //     result = `${days} day${days > 1 ? 's' : ''} ago`;
          //   } else if (hours > 0) {
          //     result = `${hours} hour${hours > 1 ? 's' : ''} ago`;
          //   } else if (minutes > 0) {
          //     result = `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
          //   } else {
          //     result = 'just now';
          //   }

          //   return (
          //     <div key={item.jobId || index} className="col-md-4 d-flex align-items-stretch mt-4">
          //       <div className="jobCard p-3  mb-4 w-100 d-flex flex-column justify-content-between">
          //         <div>
          //           <div className="d-flex justify-content-between align-items-center"
          //             style={{ height: "60px" }}>
          //             <Link to={`/JobDetail/${item.jobId}`}>
          //               <div
          //                 className="pointer me-2 d-flex"
          //               // onClick={() => {
          //               //   setShowjobDetails(true);
          //               //   setJobId(item.jobId);
          //               // }}
          //               >
          //                 <img src={item?.compLogo} alt="" width={50} height={50} style={{ borderRadius: '50px' }} />
          //                 <div>
          //                   <span className="ms-2">{item.compName}</span>
          //                 </div>
          //               </div>
          //             </Link>
          //             <JobAction
          //               item={item}
          //               AllJobList={getSavedJobs}
          //               setJobList={setSavedJobs}
          //               jobList={savedJobs}
          //               totalPages={totalPages}
          //               setTotalPages={setTotalPages}
          //               page={page}
          //             />
          //           </div>
          //           <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
          //             <Link to={`/JobDetail/${item.jobId}`}>
          //               <p
          //                 className="job-title f-16 fw-bold pointer"
          //               // onClick={() => {
          //               //   setShowjobDetails(true);
          //               //   setJobId(item.jobId);
          //               // }}
          //               >
          //                 {item.title}
          //               </p>
          //             </Link>
          //             {isSavedJobs.has(item.jobId) || item?.isSaved === true ? (
          //               <div className="d-flex align-items-center postAction me-0">
          //                 <BookmarkSharpIcon
          //                   className="material-symbols-sharp pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       unsaveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 />
          //               </div>
          //             ) : (
          //               <div className="d-flex align-items-center postAction">
          //                 <BookmarkBorderSharpIcon
          //                   className="material-symbols-outlined pointer"
          //                   onClick={() => {
          //                     if (guestModeData !== "true") {
          //                       saveJob(item?.jobId);
          //                     }
          //                   }}
          //                   disabled={guestModeData === "true"}
          //                 />
          //               </div>
          //             )}
          //           </div>
          //            <div
          //               dangerouslySetInnerHTML={{
          //                 __html: cleanShortDescription(
          //                   item.shortDescription.length > 50
          //                     ? item.shortDescription.slice(0, 50) + "..."
          //                     : item.shortDescription
          //                 ),
          //               }}
          //               style={{ fontSize: "12px", lineHeight: "1.5" }}
          //             />
          //           {/* <p className="f-14  job-description">{item.shortDescription}</p> */}
          //           <div className="d-flex justify-content-between align-items-center mt-1">
          //             {/* <small className="f-8">Posted 3 Days ago</small>
          //         <div className="badge badge-date">2 Weeks Left</div> */}
          //             <small className="f-8 ms-2">Posted {result}</small>
          //             <div className="badge badge-date">{item?.expiringInDays} days Left</div>
          //           </div>
          //           <div className="jobType mt-2 ">
          //             <div className="badge badge-job me-3">
          //               {item.jbTypName}
          //             </div>
          //             <div className="badge badge-job me-3">
          //               {item.workLocationTypeName}
          //             </div>
          //             <div className="badge badge-job">
          //               {item.designationName}
          //             </div>
          //           </div>
          //         </div>
          //         <div>
          //           <div className=" mt-3" >

          //             <JobApply isAppliedByYou={item?.isApplied} jobId={item?.jobId} getAllJobList={getAllJobList} item={item} profileConfig={profileConfig}   AddUserCcv={AddUserCcv} userCcv={userCcv} />
          //           </div>
          //         </div>

          //         {/* <div className="d-flex ms-2 mt-2">
          //         <div className="circle-container">
          //           <img
          //             src={icons.default}
          //             alt="Circle 1"
          //             className="circle-img"
          //           />
          //           <img
          //             src={icons.default}
          //             alt="Circle 2"
          //             className="circle-img"
          //           />
          //           <img
          //             src={icons.default}
          //             alt="Circle 3"
          //             className="circle-img"
          //           />
          //           <img
          //             src={icons.plus}
          //             alt="Circle 3"
          //             className="circle-img"
          //           />
          //         </div>
          //         <div className="text">13 Mutual Connects</div>
          //       </div> */}
          //       </div>
          //     </div>

          //   )
          // })
          <>
            {postsWithAds
              // ?.filter((item) => !item.isDeleted)
              .map((item, index) => {
                const now = moment();
                const itemTime = moment.utc(item?.creationTime);
                const duration = moment.duration(now.diff(itemTime));

                const years = duration.years();
                const months = duration.months();
                const days = duration.days();
                const hours = duration.hours();
                const minutes = duration.minutes();

                let result = '';

                // if (years > 0) {
                //   result = `${years} year${years > 1 ? 's' : ''} ago`;
                // } else if (months > 0) {
                //   result = `${months} month${months > 1 ? 's' : ''} ago`;
                // } else if (days > 0) {
                //   result = `${days} day${days > 1 ? 's' : ''} ago`;
                // } else if (hours > 0) {
                //   result = `${hours} hour${hours > 1 ? 's' : ''} ago`;
                // } else if (minutes > 0) {
                //   result = `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
                // } else {
                //   result = 'just now';
                // }
                 if (years > 0) {
                  result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (months > 0) {
                  result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (days > 0) {
                  result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (hours > 0) {
                  result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (minutes > 0) {
                  result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else {
                  result = t("Notifications.Just Now");
                }


                return (
                  <React.Fragment key={`post-${index}`}>
                    {item.isAd && (
                      <div className="advertiseImage">
                        <div className="advertisementview">
                          <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px",
                            overflow: "hidden",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                          }}>
                            <GoogleAdUnit
                              key={`saved-job-ad-${index}`}
                              adSlot="9135916775"
                              style={{
                                display: "block",
                                width: "100%",
                                height: "100%",
                                margin: "0 auto",
                              }}
                            />
                          </div>
                          {/* <h1 className="adText">Advertisement</h1> */}
                        </div>

                      </div>
                    )}

                    {!item.isAd && (
                      <div key={item.jobId || index} className="col-md-4 d-flex align-items-stretch mt-4">
                        <div className="jobCard p-3  mb-4 w-100 d-flex flex-column justify-content-between">
                          <div>
                            <div className="d-flex justify-content-between align-items-center"
                              style={{ height: "60px" }}>
                              <Link to={`/JobDetail/${item.jobId}`}>
                                <div
                                  className="pointer me-2 d-flex"
                                // onClick={() => {
                                //   setShowjobDetails(true);
                                //   setJobId(item.jobId);
                                // }}
                                >
                                  <img src={item?.compLogo} alt="" width={50} height={50} style={{ borderRadius: '50px' }} />
                                  <div>
                                    <span className="ms-2">{item.compName}</span>
                                  </div>
                                </div>
                              </Link>
                              <JobAction
                                item={item}
                                AllJobList={getSavedJobs}
                                setJobList={setSavedJobs}
                                jobList={savedJobs}
                                totalPages={totalPages}
                                setTotalPages={setTotalPages}
                                page={page}
                              />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
                              <Link to={`/JobDetail/${item.jobId}`}>
                                <p
                                  className="job-title f-16 fw-bold pointer"
                                // onClick={() => {
                                //   setShowjobDetails(true);
                                //   setJobId(item.jobId);
                                // }}
                                >
                                  {item.title}
                                </p>
                              </Link>
                              {isSavedJobs.has(item.jobId) || item?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction me-0">
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                            <div
                            className="jobDescription"
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  item.shortDescription?.length > 50
                                    ? item.shortDescription?.slice(0, 50) + "..."
                                    : item.shortDescription
                                ),
                              }}
                              style={{ fontSize: "12px", lineHeight: "1.5" }}
                            />
                            {/* <p className="f-14  job-description">{item.shortDescription}</p> */}
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              {/* <small className="f-8">Posted 3 Days ago</small>
                                    <div className="badge badge-date">2 Weeks Left</div> */}
                              <Tooltip title={moment.utc(item?.creationTime).local().format("DD MMM YYYY")} arrow>
                                <small className="f-8 ms-2">{t("Manage Job.Posted")} {result}</small>
                              </Tooltip>
                              <div className="badge badge-date">
                               {Number(item?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(item?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${item?.expiringInDays} ${t("Manage Job.days Left")}`}
                              </div>
                            </div>
                            <div className="jobType mt-2 ">
                              <div className="badge badge-job me-3">
                                {item.jbTypName}
                              </div>
                              <div className="badge badge-job me-3">
                                {item.workLocationTypeName}
                              </div>
                              <div className="badge badge-job">
                                {item.designationName}
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className=" mt-3" >

                              <JobApply 
                              isAppliedByYou={item?.isApplied} jobId={item?.jobId} getAllJobList={getAllJobList} item={item} profileConfig={profileConfig} AddUserCcv={AddUserCcv} userCcv={userCcv} />
                            </div>
                          </div>

                          {/* <div className="d-flex ms-2 mt-2">
                                    <div className="circle-container">
                                      <img
                                        src={icons.default}
                                        alt="Circle 1"
                                        className="circle-img"
                                      />
                                      <img
                                        src={icons.default}
                                        alt="Circle 2"
                                        className="circle-img"
                                      />
                                      <img
                                        src={icons.default}
                                        alt="Circle 3"
                                        className="circle-img"
                                      />
                                      <img
                                        src={icons.plus}
                                        alt="Circle 3"
                                        className="circle-img"
                                      />
                                    </div>
                                    <div className="text">13 Mutual Connects</div>
                                  </div> */}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </>


        }
        {!hasMoreData && savedJobs.length > 12  && (
        <p className="text-center">{t("Newsfeed.No more data available")}</p >
      )}

        {loading && savedJobs.length > 0 && (
          <div className="text-center mt-3 mb-4 w-100">
            <div className="text-center my-3">
              <img src={post?.loader} width={50} />
            </div>
            {/* <p className="mt-2">Loading more jobs...</p> */}
          </div>
        )}

        {/* <div className="seeAllBtn">
          <button>See All</button>
        </div> */}
      </div>
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p"> {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

    </>
  );
};

export default SavedJobs;
